
import React, { useState } from 'react';
import { FaBook, FaFileAlt, FaPencilAlt, FaCalendarAlt, FaCheckCircle, FaDownload, FaUserGraduate, FaClipboardList, FaGraduationCap, FaChartLine, FaLightbulb, FaTrophy, FaUsers, FaClock, FaRupeeSign, FaShieldAlt, FaMedal, FaFlag } from 'react-icons/fa';

const SainikSchoolPage = () => {
  const [selectedClass, setSelectedClass] = useState('6th');

  const classData = {
    '6th': {
      eligibility: "Students currently studying in Class 5th from a recognized school",
      ageLimit: "10-12 years as on 31st March of admission year",
      subjects: ["Mathematics", "General Intelligence", "English", "General Knowledge"],
      examPattern: {
        totalMarks: 300,
        duration: "2 Hours 30 Minutes",
        sections: [
          { name: "Mathematics", marks: 100, questions: 50 },
          { name: "General Intelligence", marks: 50, questions: 25 },
          { name: "English", marks: 100, questions: 50 },
          { name: "General Knowledge", marks: 50, questions: 25 }
        ]
      }
    },
    '9th': {
      eligibility: "Students currently studying in Class 8th from a recognized school",
      ageLimit: "13-15 years as on 31st March of admission year",
      subjects: ["Mathematics", "Intelligence", "English", "General Science", "Social Studies"],
      examPattern: {
        totalMarks: 400,
        duration: "3 Hours",
        sections: [
          { name: "Mathematics", marks: 100, questions: 50 },
          { name: "Intelligence", marks: 50, questions: 25 },
          { name: "English", marks: 100, questions: 50 },
          { name: "General Science", marks: 75, questions: 37 },
          { name: "Social Studies", marks: 75, questions: 38 }
        ]
      }
    }
  };

  const syllabus = {
    '6th': [
      {
        subject: "Mathematics",
        topics: ["Number System", "HCF & LCM", "Fractions & Decimals", "Percentage", "Ratio & Proportion", "Profit & Loss", "Simple Interest", "Time & Work", "Time & Distance", "Average", "Geometry", "Mensuration", "Data Handling"]
      },
      {
        subject: "General Intelligence",
        topics: ["Analogies", "Classification", "Series Completion", "Coding-Decoding", "Blood Relations", "Direction Sense", "Ranking & Arrangement", "Pattern Recognition", "Mirror & Water Images", "Puzzle Test", "Mathematical Operations", "Venn Diagrams"]
      },
      {
        subject: "English",
        topics: ["Reading Comprehension", "Vocabulary (Synonyms, Antonyms)", "Grammar (Tenses, Articles, Prepositions)", "Sentence Formation", "Error Detection", "Idioms & Phrases", "One Word Substitution", "Active-Passive Voice", "Direct-Indirect Speech", "Spellings"]
      },
      {
        subject: "General Knowledge",
        topics: ["Indian History & Freedom Movement", "Indian Geography", "Indian Polity & Constitution", "Indian Economy", "General Science (Physics, Chemistry, Biology)", "Sports & Games", "Awards & Honors", "Current Affairs", "Books & Authors", "Important Days & Events"]
      }
    ],
    '9th': [
      {
        subject: "Mathematics",
        topics: ["Number Systems", "Algebra", "Linear Equations", "Quadratic Equations", "Polynomials", "Geometry", "Trigonometry", "Mensuration", "Statistics", "Probability", "Coordinate Geometry", "Commercial Mathematics"]
      },
      {
        subject: "Intelligence",
        topics: ["Verbal Reasoning", "Non-Verbal Reasoning", "Logical Reasoning", "Analytical Ability", "Series & Patterns", "Coding-Decoding", "Data Interpretation", "Problem Solving", "Critical Thinking", "Spatial Reasoning"]
      },
      {
        subject: "English",
        topics: ["Reading Comprehension (Multiple Passages)", "Advanced Vocabulary", "Grammar & Usage", "Sentence Correction", "Para Jumbles", "Cloze Test", "Idioms & Phrases", "Literature (Poetry & Prose)", "Writing Skills", "Essay Writing"]
      },
      {
        subject: "General Science",
        topics: ["Physics: Motion, Force, Energy, Work & Power, Light, Sound, Electricity", "Chemistry: Matter, Atoms & Molecules, Chemical Reactions, Acids & Bases", "Biology: Cell Structure, Tissues, Nutrition, Respiration, Reproduction, Health & Diseases"]
      },
      {
        subject: "Social Studies",
        topics: ["History: Medieval & Modern India, World History", "Geography: Physical Features, Climate, Resources, Agriculture", "Civics: Democracy, Constitution, Government", "Economics: Production, Exchange, Money & Banking"]
      }
    ]
  };

  const recommendedBooks = {
    '6th': [
      { name: "All India Sainik School Entrance Exam Class 6 Guide", publisher: "Arihant Publications" },
      { name: "Sainik School Entrance Examination Class VI", publisher: "Upkar Prakashan" },
      { name: "NCERT Books Class 5 (All Subjects)", publisher: "NCERT" },
      { name: "Reasoning for Class 6", publisher: "MTG Learning Media" },
      { name: "General Knowledge 2025", publisher: "Manorama Yearbook" }
    ],
    '9th': [
      { name: "All India Sainik School Entrance Exam Class 9 Guide", publisher: "Arihant Publications" },
      { name: "Sainik School Class IX Complete Study Package", publisher: "Upkar Prakashan" },
      { name: "NCERT Books Class 8 (All Subjects)", publisher: "NCERT" },
      { name: "Lucent's General Knowledge", publisher: "Lucent Publications" },
      { name: "Previous Year Solved Papers", publisher: "Youth Competition Times" }
    ]
  };

  const sainikSchools = [
    { name: "Sainik School Amaravathinagar", state: "Tamil Nadu" },
    { name: "Sainik School Balachadi", state: "Gujarat" },
    { name: "Sainik School Bijapur", state: "Karnataka" },
    { name: "Sainik School Gopalganj", state: "Bihar" },
    { name: "Sainik School Kazhakootam", state: "Kerala" },
    { name: "Sainik School Kunjpura", state: "Haryana" },
    { name: "Sainik School Nalanda", state: "Bihar" },
    { name: "Sainik School Rewa", state: "Madhya Pradesh" },
    { name: "Sainik School Tilaiya", state: "Jharkhand" },
    { name: "Sainik School Punglwa", state: "Nagaland" },
    { name: "Sainik School Korukonda", state: "Andhra Pradesh" },
    { name: "Sainik School Ghorakhal", state: "Uttarakhand" }
  ];

  const importantDates = [
    { event: "Notification Release", date: "September - October" },
    { event: "Online Registration Start", date: "October - November" },
    { event: "Last Date to Apply", date: "December" },
    { event: "Admit Card Release", date: "December - January" },
    { event: "All India Sainik School Entrance Exam (AISSEE)", date: "January (Sunday)" },
    { event: "Result Declaration", date: "March - April" },
    { event: "Medical Examination", date: "April - May" },
    { event: "Final Merit List", date: "May - June" },
    { event: "Admission Process", date: "June - July" }
  ];

  const features = [
    { icon: <FaShieldAlt />, title: "Military Discipline", desc: "Training based on armed forces values" },
    { icon: <FaGraduationCap />, title: "Quality Education", desc: "CBSE curriculum with excellent faculty" },
    { icon: <FaMedal />, title: "NDA Preparation", desc: "Direct pathway to National Defence Academy" },
    { icon: <FaTrophy />, title: "Sports Excellence", desc: "Focus on physical fitness & sports" },
    { icon: <FaUsers />, title: "All-Round Development", desc: "Character building & leadership skills" },
    { icon: <FaFlag />, title: "Patriotic Environment", desc: "Instilling national pride & values" }
  ];

  return (
    <div style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        padding: '80px 20px 60px',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>
            <FaShieldAlt />
          </div>
          <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>
            All India Sainik School Entrance Examination (AISSEE)
          </h1>
          <p style={{ fontSize: '1.3rem', marginBottom: '30px', opacity: 0.95 }}>
            Join India's prestigious Military Schools - Building Future Leaders & Defenders
          </p>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.href = '/register'}
              style={{
                background: 'white',
                color: '#f5576c',
                padding: '15px 40px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              Register Now
            </button>
            <button
              onClick={() => document.getElementById('syllabus').scrollIntoView({ behavior: 'smooth' })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '15px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#f5576c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}
            >
              View Syllabus
            </button>
          </div>
        </div>
      </div>

      {/* Class Selection Tabs */}
      <div style={{ 
        background: 'white', 
        padding: '30px 20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
        position: 'sticky',
        top: '0',
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ 
            display: 'flex', 
            gap: '15px', 
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {['6th', '9th'].map(cls => (
              <button
                key={cls}
                onClick={() => setSelectedClass(cls)}
                style={{
                  padding: '15px 50px',
                  borderRadius: '12px',
                  border: 'none',
                  background: selectedClass === cls 
                    ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' 
                    : '#f0f0f0',
                  color: selectedClass === cls ? 'white' : '#333',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: selectedClass === cls ? '0 4px 15px rgba(245,87,108,0.4)' : 'none'
                }}
                onMouseEnter={(e) => {
                  if (selectedClass !== cls) {
                    e.currentTarget.style.background = '#e0e0e0';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedClass !== cls) {
                    e.currentTarget.style.background = '#f0f0f0';
                  }
                }}
              >
                Class {cls}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* Overview Section */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            About AISSEE for Class {selectedClass}
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '25px',
            marginBottom: '40px'
          }}>
            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#f093fb',
                marginBottom: '15px'
              }}>
                <FaUserGraduate />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Eligibility
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                {classData[selectedClass].eligibility}
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#f5576c',
                marginBottom: '15px'
              }}>
                <FaClock />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Age Limit
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                {classData[selectedClass].ageLimit}
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ 
                fontSize: '2.5rem', 
                color: '#43e97b',
                marginBottom: '15px'
              }}>
                <FaRupeeSign />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '10px', color: '#2c3e50' }}>
                Application Fee
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>
                ₹550/- (₹400/- for SC/ST candidates)
              </p>
            </div>
          </div>
        </section>

        {/* Why Sainik School */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Why Choose Sainik School?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {features.map((feature, idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '35px',
                borderRadius: '15px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: '2px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(245,87,108,0.2)';
                e.currentTarget.style.borderColor = '#f5576c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = 'transparent';
              }}>
                <div style={{ 
                  fontSize: '3.5rem',
                  color: '#f5576c',
                  marginBottom: '20px'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{ 
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#2c3e50'
                }}>
                  {feature.title}
                </h3>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.6',
                  margin: 0,
                  fontSize: '1rem'
                }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Exam Pattern */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaClipboardList style={{ marginRight: '10px', color: '#f5576c' }} />
            Exam Pattern
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '20px'
            }}>
              {recommendedBooks[selectedClass].map((book, idx) => (
                <div key={idx} style={{
                  padding: '20px',
                  border: '2px solid #e8e8e8',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#f5576c';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(245,87,108,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{ 
                    fontSize: '2rem', 
                    color: '#f5576c',
                    marginBottom: '10px'
                  }}>
                    <FaBook />
                  </div>
                  <h4 style={{ 
                    fontSize: '1.1rem', 
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    color: '#2c3e50'
                  }}>
                    {book.name}
                  </h4>
                  <p style={{ 
                    color: '#666',
                    fontSize: '0.9rem',
                    margin: 0
                  }}>
                    By {book.publisher}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Important Dates */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaCalendarAlt style={{ marginRight: '10px', color: '#f5576c' }} />
            Important Dates 2025
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ overflow: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '1.1rem'
              }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
                    <th style={{ padding: '20px', textAlign: 'left', borderRadius: '8px 0 0 0' }}>Event</th>
                    <th style={{ padding: '20px', textAlign: 'right', borderRadius: '0 8px 0 0' }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {importantDates.map((item, idx) => (
                    <tr key={idx} style={{ 
                      background: idx % 2 === 0 ? '#f8f9fa' : 'white',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <td style={{ padding: '20px', fontWeight: '600', color: '#2c3e50' }}>
                        <FaCalendarAlt style={{ marginRight: '10px', color: '#f5576c' }} />
                        {item.event}
                      </td>
                      <td style={{ padding: '20px', textAlign: 'right', color: '#666' }}>
                        {item.date}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Previous Year Papers */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaFileAlt style={{ marginRight: '10px', color: '#f5576c' }} />
            Previous Year Question Papers
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '20px'
            }}>
              {['2024', '2023', '2022', '2021', '2020', '2019'].map((year) => (
                <button key={year} style={{
                  padding: '25px',
                  borderRadius: '12px',
                  border: '2px solid #e8e8e8',
                  background: 'white',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)';
                  e.currentTarget.style.color = 'white';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = '#2c3e50';
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                  <span>AISSEE {year}</span>
                  <FaDownload />
                </button>
              ))}
            </div>
            <p style={{ 
              textAlign: 'center', 
              marginTop: '30px',
              color: '#666',
              fontSize: '1rem'
            }}>
              Click on any year to download the question paper with solutions
            </p>
          </div>
        </section>

        {/* Mock Test Section */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaPencilAlt style={{ marginRight: '10px', color: '#f5576c' }} />
            Practice Mock Tests
          </h2>

          <div style={{
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            padding: '50px',
            borderRadius: '20px',
            textAlign: 'center',
            color: 'white'
          }}>
            <h3 style={{ 
              fontSize: '2rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              Test Your Preparation Level
            </h3>
            <p style={{ 
              fontSize: '1.2rem',
              marginBottom: '30px',
              opacity: 0.95
            }}>
              Take free mock tests designed exactly like AISSEE exam pattern
            </p>
            <div style={{ 
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button style={{
                background: 'white',
                color: '#f5576c',
                padding: '15px 40px',
                borderRadius: '30px',
                border: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                Start Free Mock Test
              </button>
              <button style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '15px 40px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#f5576c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}>
                View All Test Series
              </button>
            </div>
          </div>
        </section>

        {/* Preparation Tips */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaLightbulb style={{ marginRight: '10px', color: '#f5576c' }} />
            Preparation Strategy
          </h2>

          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)'
          }}>
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {[
                {
                  title: "Start Early",
                  desc: "Begin preparation 6-8 months before the exam",
                  icon: <FaClock />
                },
                {
                  title: "Strong Basics",
                  desc: "Focus on NCERT books and fundamentals",
                  icon: <FaBook />
                },
                {
                  title: "Regular Practice",
                  desc: "Solve at least 100 questions daily",
                  icon: <FaPencilAlt />
                },
                {
                  title: "Time Management",
                  desc: "Practice solving papers within time limit",
                  icon: <FaClock />
                },
                {
                  title: "Mock Tests",
                  desc: "Take weekly full-length mock tests",
                  icon: <FaFileAlt />
                },
                {
                  title: "Physical Fitness",
                  desc: "Maintain good health and fitness routine",
                  icon: <FaTrophy />
                }
              ].map((tip, idx) => (
                <div key={idx} style={{
                  padding: '25px',
                  border: '2px solid #e8e8e8',
                  borderRadius: '12px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#f5576c';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(245,87,108,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{ 
                    fontSize: '2.5rem',
                    color: '#f5576c',
                    marginBottom: '15px'
                  }}>
                    {tip.icon}
                  </div>
                  <h4 style={{ 
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    color: '#2c3e50'
                  }}>
                    {tip.title}
                  </h4>
                  <p style={{ 
                    color: '#666',
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    {tip.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Course Packages */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '50px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            <FaRupeeSign style={{ marginRight: '10px', color: '#f5576c' }} />
            Course Packages
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {[
              {
                name: "Foundation Package",
                price: "5,999",
                duration: "3 Months",
                features: [
                  "Complete Study Material",
                  "Video Lectures (All Subjects)",
                  "15 Mock Tests",
                  "Doubt Resolution",
                  "Email Support",
                  "Previous Year Papers"
                ],
                gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
              },
              {
                name: "Advanced Package",
                price: "9,999",
                duration: "6 Months",
                features: [
                  "Everything in Foundation",
                  "Live Interactive Classes",
                  "30 Mock Tests + Sectional Tests",
                  "Weekly Assessments",
                  "Physical Fitness Guidance",
                  "Interview Preparation",
                  "WhatsApp Support Group"
                ],
                gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                popular: true
              },
              {
                name: "Elite Package",
                price: "15,999",
                duration: "12 Months",
                features: [
                  "Everything in Advanced",
                  "Personal Mentor",
                  "Unlimited Mock Tests",
                  "One-on-One Sessions",
                  "Performance Analytics",
                  "Medical Exam Preparation",
                  "Offline Study Material",
                  "24/7 Premium Support"
                ],
                gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
              }
            ].map((pkg, idx) => (
              <div key={idx} style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: pkg.popular ? '0 12px 40px rgba(245,87,108,0.3)' : '0 4px 15px rgba(0,0,0,0.08)',
                border: pkg.popular ? '3px solid #f5576c' : '1px solid #e8e8e8',
                position: 'relative',
                transform: pkg.popular ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.08)' : 'scale(1.03)';
                e.currentTarget.style.boxShadow = '0 15px 45px rgba(245,87,108,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = pkg.popular ? 'scale(1.05)' : 'scale(1)';
                e.currentTarget.style.boxShadow = pkg.popular ? '0 12px 40px rgba(245,87,108,0.3)' : '0 4px 15px rgba(0,0,0,0.08)';
              }}>
                {pkg.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '-35px',
                    background: '#FFD700',
                    color: '#333',
                    padding: '5px 40px',
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    transform: 'rotate(45deg)',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    zIndex: 1
                  }}>
                    POPULAR
                  </div>
                )}
                
                <div style={{
                  background: pkg.gradient,
                  padding: '40px 30px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <h3 style={{ 
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    {pkg.name}
                  </h3>
                  <div style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '10px' }}>
                    ₹{pkg.price}
                  </div>
                  <div style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                    {pkg.duration}
                  </div>
                </div>

                <div style={{ padding: '30px' }}>
                  <ul style={{ 
                    listStyle: 'none',
                    padding: 0,
                    margin: '0 0 25px 0'
                  }}>
                    {pkg.features.map((feature, i) => (
                      <li key={i} style={{
                        padding: '12px 0',
                        borderBottom: i < pkg.features.length - 1 ? '1px solid #f0f0f0' : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: '#555'
                      }}>
                        <FaCheckCircle style={{ color: '#43e97b', fontSize: '1.2rem', flexShrink: 0 }} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <button style={{
                    width: '100%',
                    padding: '15px',
                    borderRadius: '10px',
                    border: 'none',
                    background: pkg.gradient,
                    color: 'white',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => window.location.href = '/register'}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    Enroll Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQs */}
        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '30px',
            color: '#2c3e50',
            textAlign: 'center'
          }}>
            Frequently Asked Questions
          </h2>

          <div style={{
            background: 'white',
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
            overflow: 'hidden'
          }}>
            {[
              {
                q: "What is the eligibility for AISSEE?",
                a: "For Class 6: Students studying in Class 5 with age 10-12 years. For Class 9: Students studying in Class 8 with age 13-15 years (as on 31st March of admission year)."
              },
              {
                q: "How many Sainik Schools are there in India?",
                a: "There are 33 Sainik Schools across India, with at least one in most states and union territories."
              },
              {
                q: "Is there any reservation in Sainik Schools?",
                a: "Yes, there are reservations for SC/ST candidates and home state candidates. 67% seats are reserved for home state and 33% for all India."
              },
              {
                q: "What is the fee structure of Sainik Schools?",
                a: "The annual fee ranges from ₹80,000 to ₹1,00,000 depending on the school. Fee concessions are available for SC/ST and defense personnel children."
              },
              {
                q: "Is medical examination mandatory?",
                a: "Yes, after clearing the written exam, candidates must pass a medical examination as per Indian Armed Forces standards."
              },
              {
                q: "Can girls apply for Sainik Schools?",
                a: "Yes, Sainik Schools now admit both boys and girls. Several schools have started admitting girl students."
              },
              {
                q: "What happens after passing AISSEE?",
                a: "After clearing the written exam with required marks, candidates undergo medical examination. Final selection is based on combined performance and medical fitness."
              },
              {
                q: "Do Sainik School students get preference for NDA?",
                a: "While there's no official preference, Sainik School students are better prepared for NDA due to the military-oriented education and training."
              }
            ].map((faq, idx) => (
              <div key={idx} style={{
                padding: '30px',
                borderBottom: idx < 7 ? '1px solid #e8e8e8' : 'none'
              }}>
                <h4 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#f5576c',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ flexShrink: 0 }}>Q{idx + 1}.</span>
                  <span>{faq.q}</span>
                </h4>
                <p style={{ 
                  color: '#666',
                  lineHeight: '1.8',
                  margin: '0 0 0 35px',
                  fontSize: '1.05rem'
                }}>
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Final CTA */}
        <section>
          <div style={{
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            padding: '60px 40px',
            borderRadius: '20px',
            textAlign: 'center',
            color: 'white'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>
              <FaShieldAlt />
            </div>
            <h2 style={{ 
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              Ready to Join Sainik School?
            </h2>
            <p style={{ 
              fontSize: '1.3rem',
              marginBottom: '35px',
              opacity: 0.95,
              maxWidth: '700px',
              margin: '0 auto 35px'
            }}>
              Begin your journey towards becoming a future leader with discipline, character, and excellence
            </p>
            <div style={{ 
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button 
                onClick={() => window.location.href = '/register'}
                style={{
                  background: 'white',
                  color: '#f5576c',
                  padding: '18px 45px',
                  borderRadius: '30px',
                  border: 'none',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                }}>
                Register for Class {selectedClass}
              </button>
              <button style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '18px 45px',
                borderRadius: '30px',
                border: '2px solid white',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onClick={() => window.location.href = '/contact'}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#f5576c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.color = 'white';
              }}>
                Get Free Counselling
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Note */}
      <div style={{
        background: '#2c3e50',
        color: 'white',
        padding: '10px 10px',
        textAlign: 'center',
        marginTop: '60px'
      }}>
       
        <p style={{ margin: 0, opacity: 0.8 }}>
          For official information, visit: <a href="https://www.sainikschool.ncert.gov.in" target="_blank" rel="noopener noreferrer" style={{ color: '#43e97b', textDecoration: 'none' }}>sainikschool.ncert.gov.in</a>
        </p>
      </div>
    </div>
  );
};

export default SainikSchoolPage;